import { WEB_APPS_LIST } from "./types.js";
import { AuthWrapper2 } from "../AuthWrapper2/index.js";
import { AppShellBootstrap } from "./components/AppShellBootstrap.js";
import "react";
import { jsx } from "react/jsx-runtime";
import { camelCase } from "lodash-es";
//#region src/modules/AppWrapper2/index.tsx
function AppWrapper2(props) {
	return /* @__PURE__ */ jsx(AuthWrapper2, {
		app: {
			appName: WEB_APPS_LIST.find(({ id }) => props.currentAppId === id)?.name ?? props.currentAppOverride?.name ?? camelCase(props.currentAppId),
			appVersion: props.currentAppVersion
		},
		children: /* @__PURE__ */ jsx(AppShellBootstrap, {
			allowMultiRegionSelection: props.allowMultiRegionSelection,
			appInteractionHandlers: props.appInteractionHandlers,
			appURLOverride: props.appURLOverride,
			currentAppId: props.currentAppId,
			currentAppOverride: props.currentAppOverride,
			mapboxToken: props.mapboxToken,
			onIdentityChanged: props.onIdentityChanged,
			onLogout: props.onLogout,
			onRegionChanged: props.onRegionChanged,
			scopeAllRegions: props.scopeAllRegions,
			children: props.children
		})
	});
}
//#endregion
export { AppWrapper2 };

//# sourceMappingURL=index.js.map